export { default } from "./AssessmentDetails.gql";
